import React from "react";

// region Styles
import * as Styled from "./styles";
// endregion Styles

/** Centered, muted line for the loading / empty state of a list. */
const StateMessage: React.FC = ({ children }) => (
  <Styled.Container>{children}</Styled.Container>
);

export default StateMessage;
